export default {
  FETCH_PAYMENT_CONFIG_REQUEST: '@PAYMENT_CONFIG/FETCH_PAYMENT_CONFIG_REQUEST',
  FETCH_PAYMENT_CONFIG_SUCCESS: '@PAYMENT_CONFIG/FETCH_PAYMENT_CONFIG_SUCCESS',
  FETCH_PAYMENT_CONFIG_FAILURE: '@PAYMENT_CONFIG/FETCH_PAYMENT_CONFIG_FAILURE',

  UPDATE_DEFAULT_CURRENCY: '@EXCHANGE_RATE/UPDATE_DEFAULT_CURRENCY',

  UPDATE_SELECTED_PAYMENT_METHOD: '@PAYMENT_CONFIG/UPDATE_SELECTED_PAYMENT_METHOD',
} as const
